<template>
    <div id="funding">
        <div class="row">
            <div class="col-sm-12 col-md-11 col-lg-11">
                <div class="section-heading heading-left">
                    <span class="subtitle primary bold">Fondeo.</span>
                    <div class="row">
                        <div class="col-lg-12 mb--20">
                            <h2 class="font-weight-100">
                                Año con año, los <span class="bold">inversionistas</span> incrementan su <span class="bold">confianza</span> e inversión en nuestra plataforma.
                            </h2>
                        </div>
                        <div v-if="isMounted" class="col-12 mb--20">
                            <ul class="nav nav-underline" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="home-tab" data-bs-toggle="tab"
                                        data-bs-target="#tab-funding-anual" type="button" role="tab"
                                        aria-controls="tab-funding-anual" aria-selected="true">Acumulado</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="profile-tab" data-bs-toggle="tab"
                                        data-bs-target="#tab-funding-a" type="button" role="tab"
                                        aria-controls="tab-funding-a" aria-selected="false">Anual</a>
                                </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="tab-funding-anual" role="tabpanel"
                                    aria-labelledby="home-tab" tabindex="0">
                                    <div id="anual" class="row">
                                        <div class="col-sm-12 col-md-10 col-lg-10">
                                            <div id="chart">
                                                <VueApexCharts v-if="isGraphReady" type="line" height="350" :options="chartOptions2"
                                                    :series="series2">
                                                </VueApexCharts>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab-funding-a" role="tabpanel"
                                    aria-labelledby="profile-tab" tabindex="0">
                                    <div id="acumulado" class="row">
                                        <div class="col-sm-12 col-md-10 col-lg-10">
                                            <div id="chart">
                                                <VueApexCharts v-if="isGraphReady" type="bar" height="350" :options="chartOptions"
                                                    :series="series">
                                                </VueApexCharts>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isMounted" class="col-12">
                            <!-- TABLA TEST -->
                            <div class="table-responsive">
                                <table class="table rg-table">
                                    <thead>
                                        <tr>
                                            <th v-for="(column, index) in columns" scope="col"
                                                :class="column.bold ? 'bold' : 'normal'">{{ column.title }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(tr, index) in data">
                                            <th>{{ tr.item1 }}</th>
                                            <td>{{ explicitMoneyFormat(tr.item10, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item9, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item8, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item7, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item6, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item5, 0) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div>
                                    <small><i>* datos contemplados al cierre de mes.</i></small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper.js";
import VueApexCharts from 'vue-apexcharts';

const columns = [
    { title: "Fondeo", bold: true },
    { title: "2025*", bold: false },
    { title: "2024", bold: false },
    { title: "2023", bold: false },
    { title: "2022", bold: false },
    { title: "2021", bold: false },
    { title: "2020", bold: false },
]
const data = [
    {
        item1: "Anual",
        item2: 0,
        item3: 0,
        item4: 0,
        item5: 0,
        item6: 0,
        item7: 0,
        item8: 0,
        item9: 0,
    },
    {
        item1: "Acumulado",
        item2: 0,
        item3: 0,
        item4: 0,
        item5: 0,
        item6: 0,
        item7: 0,
        item8: 0,
        item9: 0,
    },
]

export default {
    name: "Payments",
    props: ["rgStats", "isMounted"],
    mixins: [
        formatHelper
    ],
    components: {
        VueApexCharts
    },
    data: () => ({
        columns: columns,
        data: data,
        publicSiteYield: null,
        isGraphReady: false,
        maxValue: 0,
        series: [{
            name: 'Anual',
            data: [0, 0, 0, 0, 0, 0]
        }],
        series2: [{
            name: 'Acumulado',
            data: [0, 0, 0, 0, 0, 0]
        }],
        chartOptions: {
            chart: {
                type: 'bar',
                height: 350,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                }
            },
            tooltip: {
                enabled: false
            },
            colors: ["#28DE18", "#CBFF00"],
            dataLabels: {
                enabled: false,
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 0,
                    dataLabels: {
                        total: {
                            enabled: false,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900
                            }
                        }
                    }
                },
            },
            xaxis: {
                categories: ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
            },
            yaxis: {
                min: 0,
                max: 1200000000,
                tickAmount: 5,
                labels: {
                    style: {
                        colors: '#3B3A3E',
                    },
                    floating: true,
                    formatter: function (val) {
                        let value = (val / 1).toFixed(0).replace(",", ".");
                        let money = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if (money == null) return "";
                        else {
                            return "$" + money
                        }
                    }
                },
            },
            legend: {
                position: 'right',
                offsetY: 40,
                show: true,
                showForSingleSeries: true,
            },
            fill: {
                opacity: 1
            }
        },
        chartOptions2: {
            chart: {
                type: 'line',
                height: 350,
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                },
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.2
                },
            },
            tooltip: {
                enabled: false
            },
            grid: {
                show: true,
                borderColor: '#999FAE',
                strokeDashArray: 15,
                position: 'back',
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                yaxis: {
                    lines: {
                        show: true
                    }
                },
                row: {
                    colors: undefined,
                    opacity: 0.5
                },
                column: {
                    colors: undefined,
                    opacity: 0.5
                },
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
            },
            colors: ["#28DE18", "#CBFF00", "#3b3a3e"],
            dataLabels: {
                enabled: true,
                offsetX: 0,
                offsetY: 0,
                textAnchor: 'middle',
                distributed: false,
                background: {
                    color: "#FFF",
                    enabled: true,
                    foreColor: '#000',
                    opacity: 0.9,
                    borderWidth: 1,
                    borderColor: '#fff'
                },
                formatter: function (val) {
                    
                    let value = (val / 1000000).toFixed(0).replace(",", ".");
                    let money = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    if (money == null) return "";
                    else {
                        return money + "M";
                    }
                    
                }
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            xaxis: {
                categories: ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
            },
            yaxis: {
                tickAmount: 3,
                labels: {
                    style: {
                        colors: '#3B3A3E',
                    },
                    floating: true,
                    formatter: function (val) {
                        let value = (val / 1).toFixed(0).replace(",", ".");
                        let money = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if (money == null) return "";
                        else {
                            return "$" + money
                        }
                    }
                },
            },
            legend: {
                position: 'right',
                offsetY: 40,
                show: true,
                showForSingleSeries: true,
            },
            fill: {
                opacity: 1
            }
        },

    }),
    mounted() {
        this.getStats();
    },
    methods: {
        getStats() {
            if(this.isMounted){
                const rg_stats = this.rgStats;
                this.publicSiteYield = JSON.parse(rg_stats.public_site_yield);
                let index = 2;
                let chartIndex = 0;
                let accumulated = 0;
                let values = [];
                this.chartOptions.xaxis.categories = [];
                this.chartOptions2.xaxis.categories = [];
                this.publicSiteYield.funding.forEach(item => {
                    accumulated += item.sum_2;
                    this.data[0][`item${index}`] = item.sum;
                    this.data[1][`item${index}`] = accumulated;

                    values.push(item.sum);
                    
                    this.series[0].data[chartIndex] = item.sum;
                    this.series2[0].data[chartIndex] = accumulated;
                    index++;
                    chartIndex++;
                    this.maxValue = Math.max(...values);
                    this.chartOptions.xaxis.categories.push(item.balance_date.slice(0,4));
                    this.chartOptions2.xaxis.categories.push(item.balance_date.slice(0,4));
                });
                this.isGraphReady = true;

                let newValue = this.maxValue + 10000000;

                this.chartOptions.yaxis.max = Math.round(newValue / 1000) * 1000;
            }
        },
    }
}
</script>

<style scoped>
a.nav-link.active {
    border-bottom: 2px solid var(--color-primary) !important;
}

.nav-underline .nav-link.active .nav-link:focus,
.nav-underline .nav-link:hover {
    border-bottom: 2px solid var(--color-primary) !important;
}

.nav-link {
    color: var(--color-black) !important;
    font-weight: bold;
    font-size: 20px;
}</style>